import { api } from './api';

type DraftState<T> = { status: 'running' } | { status: 'done'; result: T } | { status: 'failed'; error: string };

/** AI drafts run in the background on the server; this polls until one is ready (or fails). */
export async function waitForDraft<T>(id: string, signal?: AbortSignal): Promise<T> {
  const started = Date.now();
  for (;;) {
    if (signal?.aborted) throw new Error('Cancelled');
    const s = await api.get<DraftState<T>>(`/api/drafts/${id}`);
    if (s.status === 'done') return s.result;
    if (s.status === 'failed') throw new Error(s.error);
    if (Date.now() - started > 5 * 60_000) throw new Error('The AI took too long. Try again, or use the template.');
    await new Promise((r) => setTimeout(r, 2000));
  }
}

/** Starts a draft and waits for it. */
export async function draft<T>(url: string, body: unknown, signal?: AbortSignal): Promise<T> {
  const { id } = await api.post<{ id: string }>(url, body);
  return waitForDraft<T>(id, signal);
}
